import React from "react";

const SelectOptionsButton = ({ selectedTags, onEdit }) => (
  <div className="w-full flex flex-wrap items-center text-c1 pt-[16px]">
    {selectedTags.map(({ key, prefix, label }, idx) => (
      <React.Fragment key={key}>
        {/* 중간의 '·' 구분자 */}
        {idx > 0 && <span className="w-[4px] h-[4px] rounded-full bg-border-default mx-[4px]"></span>}

        {/* <button
          type="button"
          onClick={() => onEdit(key)}
          className="flex items-center text-text-subtle"
        > */}
          <span className="text-c2 text-text-subtler px-[4px]">{prefix}</span>
          <span className="text-c1 text-text-default px-[4px]">{label}</span>
        {/* </button> */}
      </React.Fragment>
    ))}
  </div>
);

export default SelectOptionsButton;
